import useAuthenticatedWebsocket from './useAuthenticatedWebSocket';

export default function useForwardMessage() {
  const { sendJsonMessage } = useAuthenticatedWebsocket();

  return (chatId, messageDeliveryToken) => sendJsonMessage({
    action: 'forward_message',
    body: {
      delivery_token: messageDeliveryToken,
      chat_id: chatId,
    },
  });
}
